module.exports = __webpack_public_path__ + "static/media/home_form_ar.3c7b2b4d.png";